module.exports = __webpack_public_path__ + "img/img5.59ba6d1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/case/05/img5.png
// module id = 244
// module chunks = 0